/**
 * L2/L3 per-form counts, durations and readiness, without importing the banks (they carry
 * answer keys and must stay server-side). Values: src/data/bankMeta.json, generated by
 * scripts/build-bank-meta.mjs from src/data/l2 and src/data/l3 (same functions, same results).
 */
import meta from '../data/bankMeta.json';

function form(level, formId) {
  const forms = meta[level]?.forms || {};
  const id = Number(formId) || 1;
  // L2 falls back to Mock 1 for an unknown form (getL2MockItemSets); L3 has no fallback.
  return forms[id] || (level === 'l2' ? forms[1] : null) || { count: 0, seconds: 0, ready: false };
}

export const l2MockQuestionCount = (formId = 1) => form('l2', formId).count;
export const l2MockSeconds = (formId = 1) => form('l2', formId).seconds;
export const l2MockReady = (formId = 1) => Boolean(meta.l2?.forms?.[Number(formId) || 1]?.ready);
export const l2ReadyMockCount = () => meta.l2?.readyCount || 0;
export const l2SampleBankCount = l2MockQuestionCount;

export const l3MockQuestionCount = (formId = 1) => form('l3', formId).count;
export const l3MockSeconds = (formId = 1) => form('l3', formId).seconds || 150; // l3MockSeconds of an empty form
export const l3MockReady = (formId = 1) => Boolean(meta.l3?.forms?.[Number(formId) || 1]?.ready);
export const l3ReadyMockCount = () => meta.l3?.readyCount || 0;
export const l3SampleBankCount = l3MockQuestionCount;
